import { get } from "../api"
import * as url from "./urls"

const getWorkflowTypes = () => {
  return get(url.GET_WORKFLOWTYPES)
}

export { getWorkflowTypes }
